import React from 'react';
import PropTypes from 'prop-types';
import { useDrag, useDrop } from 'react-dnd';
import cx from 'classnames';

const ZolaColumnItem = ({ assignment, fieldName, isTarget, mapZolaColumn, unmapZolaColumn }) => {
  // set draggable stuff
  const [{ isDragging }, dragRef] = useDrag({
    item: { type: 'ZOLA_COL', name: fieldName, assignment },
    collect: monitor => ({
      isDragging: monitor.isDragging(),
    }),
  });
  // handler when dropping one zola-field on top of another
  const replaceCol = item => {
    const { name: newZolaCol } = item;
    unmapZolaColumn(assignment, fieldName);
    mapZolaColumn(assignment, newZolaCol);
  };
  // set as drop target (when in user column)
  const [, dropRef] = useDrop({
    accept: 'ZOLA_COL',
    drop: item => replaceCol(item),
  });

  const draggableClass = cx('zola-list__item', {
    'drag-active': isDragging,
  });

  // zola field, ready for assignment
  if (assignment === null)
    return (
      <div className={draggableClass} ref={el => dragRef(el)}>
        <span className="item__text">{fieldName}</span>
      </div>
    );
  // zola field, assigned to & placed next to user field
  if (isTarget)
    return (
      <div className={draggableClass} ref={el => dragRef(dropRef(el))}>
        <span className="item__text">{fieldName}</span>
      </div>
    );
  // inactive zola field placeholder
  return (
    <div className="zola-list__item placeholder">
      <span className="item__text">{fieldName}</span>
    </div>
  );
};

ZolaColumnItem.propTypes = {
  assignment: PropTypes.string,
  fieldName: PropTypes.string,
  isTarget: PropTypes.bool,
  mapZolaColumn: PropTypes.func,
  unmapZolaColumn: PropTypes.func,
};

export default ZolaColumnItem;



// WEBPACK FOOTER //
// ./src/components/manage/guestlist/upload/ZolaColumnItem.jsx